import type { FocusableElement } from "@react-types/shared";
import { clsx } from "clsx";
import type { DOMAttributes, FC, PropsWithChildren } from "react";

import formStyle from "../../styles/form.module.css";

type FormErrorProps = DOMAttributes<FocusableElement>;

export const FormError: FC<PropsWithChildren<FormErrorProps>> = ({ children, ...props }) => {
  return (
    <div
      role="alert"
      {...props}
      className={clsx(formStyle.error_message, formStyle.input_layout_column1)}
      data-testid="number-field-error"
    >
      {children}
    </div>
  );
};
